// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__UZwrc","description":"style_description__T5Ofy","actions":"style_actions__8eh+p","actions_btn":"style_actions_btn__QdRzE"};